module.exports = __webpack_public_path__ + "img/stage.0b6b3e7b.svg";